import React from 'react';
import i18next from 'i18next';
import {AllHtmlEntities} from 'html-entities';
import styled from 'styled-components';

import Markdown from './markdown';

interface Props {
    translationKey: string;
    translationOpts?: object;
    onLinkClick?: (e: any) => void;
}

const StyledMarkdown = styled(Markdown)`
    p {
        margin: 0;
        display: inline;
    }
`;

const HTML_ENTITIES = new AllHtmlEntities();

const TranslatedMarkdown: React.FC<React.PropsWithChildren<Props>> = ({
    translationKey,
    translationOpts,
    onLinkClick,
}) => {
    const encodedTranslationOpts = React.useMemo(() => {
        if (!translationOpts) {
            return undefined;
        }

        return Object.keys(translationOpts).reduce(
            (reduction, key) => ({
                ...reduction,
                [key]:
                    typeof translationOpts[key] === 'number'
                        ? translationOpts[key]
                        : HTML_ENTITIES.encode(translationOpts[key]),
            }),
            {},
        );
    }, [translationOpts]);

    return (
        <StyledMarkdown
            source={i18next.t(translationKey, encodedTranslationOpts)}
            skipHtml={false}
            onLinkClick={onLinkClick}
        />
    );
};

export default TranslatedMarkdown;
